import '../css/common/common.css';
import '../css/common/content-wrapper.css';
import '../css/common/banner-wrapper.css';
import '../css/common/pattern-cover.css';
import '../css/common/section-block.css';
import '../css/common/button-effect.css';

import '../css/image-block.css';
import '../css/transportation/map-section/transportation-list.css';
import '../css/transportation/transportation-item.css';
import '../css/transportation/googlemap-button.css';

import '../js/importCommonCss';
import setup from './setupCommonJS';
import { uploadUri } from './appConfig';
import wordingSetter from './wordingSetter';
import getWordingJson from './request/wordingJson';
import getScheduleList from './request/scheduleList';
import generateScheduleBlock from './transportation/generateScheduleBlock';
import hideLoadingImage from './common/hideLoadingImage';

setup();

const wordingJsonPromise = getWordingJson('transportation')
	.then((json) => wordingSetter(json));

const scheduleListPromise = getScheduleList(0, 3)
	.then((json) => {
		json.schedules.forEach((item) => {
			document.querySelector('.section-block > .content.-row.-images')
				.appendChild(
					generateScheduleBlock(item.id, item.title, `${uploadUri}/${item.thumb}`),
				);
		});
	});

/**
 * make sure each promise is finished
 */
Promise.all([wordingJsonPromise, scheduleListPromise])
	.then(() => hideLoadingImage());



// WEBPACK FOOTER //
// ./src/js/transportation.js